import React from "react";
import {ChevronLeft, ChevronRight} from "react-bootstrap-icons";

export default function Pagination({ currentPage, totalPages, onPageChange }) {
    if (!totalPages || totalPages <= 1) return null;

    const siblingCount = 2;

    // totalPages הוא מספר כולל הדפים (לא האינדקס האחרון)
    const startPage = Math.max(0, currentPage - siblingCount);
    const endPage = Math.min(totalPages - 1, currentPage + siblingCount);

    const pages = [];

    if (startPage > 0) {
        pages.push(0);
        if (startPage > 1) {
            pages.push("ellipsis-left");
        }
    }

    for (let page = startPage; page <= endPage; page++) {
        pages.push(page);
    }

    if (endPage < totalPages - 1) {
        if (endPage < totalPages - 2) {
            pages.push("ellipsis-right");
        }
        pages.push(totalPages - 1);
    }

    return (
        <div className="pagination">
            {/* Prev */}
            <button
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 0}
                aria-label="Previous page"
            >
               <ChevronLeft/>
            </button>

            {/* Page numbers */}
            {pages.map((item, idx) =>
                item === "ellipsis-left" || item === "ellipsis-right" ? (
                    <span key={idx} className="ellipsis">…</span>
                ) : (
                    <button
                        key={`${item}-${idx}`}
                        onClick={() => onPageChange(item)}
                        disabled={item === currentPage}
                        className={item === currentPage ? "active" : ""}
                    >
                        {item + 1}
                    </button>
                )
            )}

            {/* Next */}
            <button
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages - 1}
                aria-label="Next page"
            >
                <ChevronRight/>
            </button>

            <style>{`
        .pagination {
          display: flex;
          align-items: center;
          gap: 4px;
          font-family: sans-serif;
          font-size: 14px;
          color: #555;
        }
        .pagination button {
          min-width: 28px;
          height: 28px;
          border: none;
          background: transparent;
          cursor: pointer;
          border-radius: 6px;
          color: inherit;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .pagination button i {
          font-size: 1.2rem;
        }
        .pagination button:hover:not(:disabled) {
          background: rgba(0,0,0,0.04);
        }
        .pagination button:disabled {
          opacity: 0.3;
          cursor: not-allowed;
        }
        .pagination button.active {
          border: 1px solid #8b5cf6;
          color: #8b5cf6;
        }
        .pagination .ellipsis {
          padding: 0 6px;
          color: #888;
          user-select: none;
        }
      `}</style>
        </div>
    );
}
